import { Link } from "react-router-dom";
import { Mail, Github, Twitter } from "lucide-react";
import { Emblem } from "./Emblem";

export default function Footer() {
  return (
    <footer className="relative bg-ink-900 border-t border-white/5 mt-32" data-testid="site-footer">
      {/* Spain flag accent stripe (subtle) */}
      <div className="h-1 stripe-flag opacity-60" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-4">
              <Emblem className="h-9 w-9" />
              <div>
                <div className="font-display font-extrabold text-white tracking-tight">TestOpoGuardiaCivil</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-gcgold font-bold font-mono">Élite · Preparación</div>
              </div>
            </div>
            <p className="text-sm text-slate-400 max-w-md leading-relaxed">
              La plataforma profesional para preparar la oposición a la Guardia Civil:
              temario, ortografía, inglés y psicotécnicos con simulacros oficiales y estadísticas avanzadas.
            </p>
            <div className="mt-6 flex gap-2">
              <a href="#" className="h-9 w-9 rounded-xl bg-white/5 hover:bg-white/10 border border-white/5 flex items-center justify-center text-slate-400 hover:text-white transition-colors"><Twitter className="h-4 w-4" /></a>
              <a href="#" className="h-9 w-9 rounded-xl bg-white/5 hover:bg-white/10 border border-white/5 flex items-center justify-center text-slate-400 hover:text-white transition-colors"><Github className="h-4 w-4" /></a>
              <a href="mailto:hola@testopoguardiacivil.com" className="h-9 w-9 rounded-xl bg-white/5 hover:bg-white/10 border border-white/5 flex items-center justify-center text-slate-400 hover:text-white transition-colors"><Mail className="h-4 w-4" /></a>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-gcgold mb-4 font-mono">Tests</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/tests" className="text-slate-400 hover:text-white transition-colors">Temario</Link></li>
              <li><Link to="/tests" className="text-slate-400 hover:text-white transition-colors">Ortografía</Link></li>
              <li><Link to="/tests" className="text-slate-400 hover:text-white transition-colors">Inglés</Link></li>
              <li><Link to="/tests" className="text-slate-400 hover:text-white transition-colors">Psicotécnicos</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-gcgold mb-4 font-mono">Plataforma</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/register" className="text-slate-400 hover:text-white transition-colors">Crear cuenta</Link></li>
              <li><Link to="/login" className="text-slate-400 hover:text-white transition-colors">Iniciar sesión</Link></li>
              <li><Link to="/ranking" className="text-slate-400 hover:text-white transition-colors">Ranking</Link></li>
              <li><Link to="/forgot-password" className="text-slate-400 hover:text-white transition-colors">Recuperar contraseña</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-gcgold mb-4 font-mono">Legal</div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#" className="text-slate-400 hover:text-white transition-colors">Aviso legal</a></li>
              <li><a href="#" className="text-slate-400 hover:text-white transition-colors">Privacidad</a></li>
              <li><a href="#" className="text-slate-400 hover:text-white transition-colors">Cookies</a></li>
              <li><Link to="/contacto" className="text-slate-400 hover:text-white transition-colors">Contacto</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} TestOpoGuardiaCivil — Todos los derechos reservados.</div>
          <div className="font-mono">Hecho con ♥ en España</div>
        </div>
      </div>
    </footer>
  );
}
